export const securitiesStorageKey = {
  tradeIsLogin: 'tradeIsLogin',
  accessToken: 'securitiesAccessToken',
  refreshToken: 'securitiesRefreshtoken',
  targetAPI: 'securitiesTarget',
  stockbitFormula: 'formulaStockbit',
};
